import { apiClient } from '@/lib/apiClient';

import type { Opg, OpgCreate, OpgUpdate } from './types';

const base = (uidProtocolo: string) => `/protocolos/${uidProtocolo}/analisis-opg`;

export const opgApi = {
  async create(uidProtocolo: string, data: OpgCreate, signal?: AbortSignal): Promise<Opg> {
    const response = await apiClient.post<Opg>(base(uidProtocolo), data, { signal });
    return response.data;
  },

  async listByProtocolo(uidProtocolo: string, signal?: AbortSignal): Promise<Opg[]> {
    const response = await apiClient.get<Opg[]>(base(uidProtocolo), { signal });
    return response.data;
  },

  async getById(uidProtocolo: string, uidAnalisis: string, signal?: AbortSignal): Promise<Opg> {
    const response = await apiClient.get<Opg>(`${base(uidProtocolo)}/${uidAnalisis}`, { signal });
    return response.data;
  },

  async update(
    uidProtocolo: string,
    uidAnalisis: string,
    data: OpgUpdate,
    signal?: AbortSignal
  ): Promise<Opg> {
    const response = await apiClient.patch<Opg>(
      `${base(uidProtocolo)}/${uidAnalisis}`,
      data,
      { signal }
    );
    return response.data;
  },

  async remove(uidProtocolo: string, uidAnalisis: string, signal?: AbortSignal): Promise<void> {
    await apiClient.delete(`${base(uidProtocolo)}/${uidAnalisis}`, { signal });
  },
};
